import './style.css';

import { Button } from '@zinc/ui';
import type DraftStore from 'bz-draft/modules/stores/draft-store';
import Icon from 'bz-icons/src/controls/icon';
import { action } from 'mobx';
import React from 'react';

export interface IProps {
  store: DraftStore;
}
class SelectionBar extends React.Component<IProps> {
  render() {
    let { highlight } = this.props.store;

    return (
      <Button.Group>
        <Button
          variant="faded"
          color={highlight ? 'primary' : 'neutral'}
          onClick={this.onHighlight}
        >
          <Icon height={16} width={16} value="0002_highlight" />
        </Button>
        <Button variant="faded" onClick={this.onSnippet}>
          <i className="fa fa-scissors" />
        </Button>
      </Button.Group>
    );
  }

  @action.bound
  onHighlight() {
    let { store } = this.props;
    store.highlight = !store.highlight;
  }

  @action.bound
  onSnippet() {
    this.props.store.onSnippet();
  }
}

export { SelectionBar };
export default SelectionBar;
